export default __webpack_public_path__ + "static/media/SearchLogs.21393828.md";